export default __webpack_public_path__ + "static/media/scooter.bg.a7977d7f.svg";